/* thappie Custom Sections — Interaktionen (kollisionsfrei, alles über data-Attribute) */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.querySelector('.thappie-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'thappie toast thappie-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- Scroll-Reveal ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('.rv:not(.in)');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Fortschrittsbalken ---------- */
  function initProgress(root) {
    var fills = root.querySelectorAll('.progress .fill[data-fill]');
    if (!fills.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.width = e.target.getAttribute('data-fill') + '%';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    fills.forEach(function (f) { io.observe(f); });
  }

  /* ---------- Vorher/Nachher (Drag) ---------- */
  function initBA(root) {
    root.querySelectorAll('.ba[data-thappie-ba]').forEach(function (ba) {
      var setPos = function (v) {
        v = Math.min(95, Math.max(5, v));
        ba.style.setProperty('--ba-pos', v + '%');
      };
      setPos(50);
      var posFromEvent = function (e) {
        var r = ba.getBoundingClientRect();
        return ((e.clientX - r.left) / r.width) * 100;
      };
      ba.addEventListener('pointerdown', function (e) {
        ba.classList.add('dragging');
        ba.setPointerCapture(e.pointerId);
        setPos(posFromEvent(e));
        e.preventDefault();
      });
      ba.addEventListener('pointermove', function (e) {
        if (ba.classList.contains('dragging')) setPos(posFromEvent(e));
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        ba.addEventListener(ev, function () { ba.classList.remove('dragging'); });
      });
    });
  }

  /* ---------- Galerie (weiches Umschalten, Bilder vorgeladen) ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-thappie-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-main-img]');
      if (!main) return;
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.th[data-src]'));
      if (!thumbs.length) return;

      // Grosse Bilder im Leerlauf vorladen, damit das Umschalten spaeter sofort ist
      var preload = function () {
        thumbs.forEach(function (t) {
          var s = t.getAttribute('data-src');
          if (s) { var im = new Image(); im.decoding = 'async'; im.src = s; }
        });
      };
      if ('requestIdleCallback' in window) { requestIdleCallback(preload); } else { setTimeout(preload, 800); }

      main.style.transition = 'opacity .22s ease';
      var busy = false;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src || busy || main.src === src || main.currentSrc === src) return;
          busy = true;
          g.querySelectorAll('.th').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');

          var img = new Image();
          img.decoding = 'async';
          img.src = src;
          var decoded = img.decode ? img.decode().catch(function () {}) : Promise.resolve();

          main.style.opacity = 0;
          Promise.all([decoded, new Promise(function (r) { setTimeout(r, 200); })]).then(function () {
            main.src = src;
            var ss = thumb.getAttribute('data-srcset');
            if (ss) main.srcset = ss;
            main.style.opacity = 1;
            busy = false;
          });
        });
      });
    });
  }

  /* ---------- Mit Eltern teilen ---------- */
  function initShare(root) {
    root.querySelectorAll('[data-thappie-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-share-text') || '';
        var url = btn.getAttribute('data-share-url') || window.location.href;
        var full = text + ' ' + url;
        if (navigator.share) {
          navigator.share({ text: text, url: url }).catch(function () {});
        } else {
          window.open('https://wa.me/?text=' + encodeURIComponent(full), '_blank');
        }
      });
    });
  }

  /* ---------- Produkt: Optionen (Tiers, Größe, Farbe) → Variante ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-thappie-product]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('script[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = document.getElementById(wrap.getAttribute('data-form-id'));
      var idInput = form ? form.querySelector('input[name="id"]') : null;

      function selectedOptions() {
        var opts = [];
        wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var sel = group.querySelector('.selected[data-value]');
          if (sel) opts[idx] = sel.getAttribute('data-value');
        });
        return opts;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
        });
      }

      function update() {
        var v = findVariant(selectedOptions());
        if (!v) return;
        if (idInput) idInput.value = v.id;
        var set = function (sel, html) {
          wrap.querySelectorAll(sel).forEach(function (n) { n.innerHTML = html; });
        };
        set('[data-price-now]', v.price_formatted);
        var old = wrap.querySelector('[data-price-old]');
        if (old) {
          old.innerHTML = v.compare_formatted || '';
          old.style.display = v.compare_formatted ? '' : 'none';
        }
        var save = wrap.querySelector('[data-price-save]');
        if (save) {
          save.textContent = v.save_formatted ? 'Du sparst ' + v.save_formatted : '';
          save.style.display = v.save_formatted ? '' : 'none';
        }
        set('[data-rate]', v.rate_formatted);
        var cta = wrap.querySelector('[data-main-cta]');
        if (cta) {
          cta.disabled = !v.available;
          var ctaSel = wrap.querySelector('.selected[data-cta]');
          var label = ctaSel ? ctaSel.getAttribute('data-cta') : cta.getAttribute('data-label-default');
          cta.textContent = v.available ? label : cta.getAttribute('data-label-soldout');
        }
        var sticky = document.querySelector('[data-thappie-sticky-price]');
        if (sticky) sticky.innerHTML = v.price_formatted;
      }

      // Klick-Handling für Tier-Karten, Chips und Swatches
      wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        group.querySelectorAll('[data-value]').forEach(function (el) {
          el.addEventListener('click', function () {
            if (el.classList.contains('disabled')) return;
            group.querySelectorAll('[data-value]').forEach(function (s) { s.classList.remove('selected'); });
            el.classList.add('selected');
            var note = group.getAttribute('data-note-target');
            if (note) {
              var target = wrap.querySelector(note);
              if (target && el.getAttribute('data-note')) target.innerHTML = el.getAttribute('data-note');
            }
            update();
          });
        });
      });
      update();
    });
  }

  /* ---------- FAQ: natives details-Toggle absichern (falls Theme-JS stört) ---------- */
  function initFaq(root) {
    root.querySelectorAll('.thappie details.faq > summary').forEach(function (sum) {
      if (sum._thappieFaq) return;
      sum._thappieFaq = true;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var det = sum.parentElement;
        det.open = !det.open;
      });
    });
  }

  function initAll(root) {
    initReveal(root); initProgress(root); initBA(root);
    initGallery(root); initShare(root); initProduct(root); initFaq(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  /* Shopify Theme Editor: Sektion neu geladen */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.thappieToast = toast;
})();
